'use client';

import { Button } from '#/components/ui/button';
import { useLocaleStore } from '#/contexts/locale-store';
import { cn } from '#/lib/utils';
import { LocaleId, useIntl } from 'intl-lib';
import { Globe } from 'lucide-react';
import { ComponentProps, useMemo } from 'react';

export function LocaleSwitcher({
  className,
  ...props
}: ComponentProps<'button'>) {
  const localeOptions = useMemo(
    () => [
      {
        label: 'EN',
        value: 'en-US',
      },
      {
        label: '简',
        value: 'zh-CN',
      },
    ],
    []
  );
  const locale = useIntl(state => state.locale);
  const setLocale = useLocaleStore(state => state.setLocale);

  return localeOptions
    .filter(option => option.value !== locale)
    .map(option => (
      <Button
        key={option.value}
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setLocale(option.value as LocaleId)}
        className={cn('text-accent-foreground', className)}
        {...props}
      >
        <Globe />
        {option.label}
      </Button>
    ));
}
